export default __webpack_public_path__ + "static/media/icon_B.9abf0671.svg";